import { Flex } from "antd";
import React from "react";

import TopTreatmentsByPlanType from "./TopTreatmentsByPlanType";
import TopPerformedProcedures from "./TopPerformedProcedures";
import TreatmentCorrelations from "./TreatmentCorrelations";
import TreatmentsStatistics from "./TreatmentsStatistics";
import FutureProcedures from "./FutureProcedures";
import ActivePatients from "./ActivePatients";

import "./styles.css";

export default function TreatmentAnalytics({ boardStatisticsData }) {
  const { active_treatments_count, top_future_procedure_code, top_procedure_codes, total_patient_responsibility } = boardStatisticsData;

  return (
    <Flex vertical gap={30}>
      <div className="treatment-statistics-section">
        <TopPerformedProcedures topProcedureCodes={top_procedure_codes} />
        <TreatmentsStatistics totalPatientResponsibility={total_patient_responsibility} activeTreatmentsCount={active_treatments_count} />
      </div>

      <div className="treatment-statistics-section">
        <TreatmentCorrelations />
        <FutureProcedures futureProcedureCodes={top_future_procedure_code} />
      </div>

      <div className="treatment-statistics-section">
        <ActivePatients />
        <TopTreatmentsByPlanType />
      </div>

      {/* <div className="show-below-1200">
        <TreatmentCorrelations />
        <ActivePatients />
      </div> */}
    </Flex>
  );
}
